/** PO net (excl. VAT, after discount %) — must match backend `getPurchaseNetAmountExclusive` */
export const CEO_NET_AMOUNT_THRESHOLD = 50000

export function getPurchaseNetAmountExclusive (purchase) {
  if (!purchase) return 0
  const products = purchase.PurchaseProduct || []
  let sum = 0
  if (Array.isArray(products) && products.length > 0) {
    sum = products.reduce((acc, p) => {
      const price = Number(p.price) || 0
      const qty = Number(p.quantity) || 0
      return acc + price * qty
    }, 0)
  } else {
    const parseNumber = (v) => {
      if (v == null) return 0
      if (typeof v === 'number') return v
      const s = String(v).replace(/[^0-9.-]+/g, '')
      const n = Number(s)
      return isNaN(n) ? 0 : n
    }
    sum = parseNumber(purchase.amount)
  }
  const discountPercent = Number(purchase.discount) || 0
  const discountAmount = sum * (discountPercent / 100)
  return Math.max(0, sum - discountAmount)
}

/** PO total (incl. VAT, after discount %) — matches PDF Total Due */
export function getPurchaseTotalAmount (purchase) {
  if (!purchase) return 0
  const net = getPurchaseNetAmountExclusive(purchase)
  const rawVat = purchase?.vat
  const hasVat = rawVat === true || rawVat === 1 || rawVat === 'true' || rawVat === '1'
  const vat = hasVat ? net * 0.16 : 0
  return net + vat
}

/** Match backend `hidePostHodApprovalColumns` — HOD = stamp/stamping rejection */
export function parsePurchaseRejectedAtStage (purchase) {
  if (!purchase || String(purchase.status || '').toLowerCase() !== 'rejected') return null
  const rej = (purchase.Approval || []).find(a => String(a.type || '').toLowerCase() === 'rejected')
  if (!rej) return null
  const m = String(rej.details || '').match(/rejected_at_stage:([^\s\n]+)/i)
  return m ? m[1].toLowerCase().trim() : null
}

export function hidePostHodApprovalColumns (purchase) {
  const st = parsePurchaseRejectedAtStage(purchase)
  return st === 'stamp' || st === 'stamping'
}
